module.exports = __webpack_public_path__ + "img/logo_w.8e0f6326.svg";